import React, { useEffect, useState } from "react";
import "./Cards.css";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import "react-responsive-modal/styles.css";
import Spinner from "../Loader/Spinner";
import Highcharts from "highcharts";
import {
  getdistictName,
  getAllBlocksFromDistrict,
  school_name_block_wise,
  getDashboardPendingRequirements,
  getDashboardCompletedRequirements,
  getDashboardAllRequirements,
  getDashboardRejectedRequirements,
  amenity_wise_req_kpi_dashboard,
  amenity_wise_shortage_count_kpi_dashboard,
} from "../../api/Users";
import Map from "../Map/Map";
import HighchartsReact from "highcharts-react-official";
import { toast } from "react-toastify";

const AdminCards = (props) => {
  const { t } = useTranslation();
  const [DistrictName, setDistrictName] = useState([]);
  const [AllSchoolNames, setAllSchoolNames] = useState([]);
  const [District, setDistrict] = useState("");
  const [Allblocks, setAllBlocks] = useState([]);
  const [Block, setBlock] = useState("");
  const [schoolId, setSchoolId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [assetsOptions, setAssetsOptions] = useState();
  const [assetsOptionsCheck, setAssetsOptionsCheck] = useState(true);
  const [assets2Options, setAssets2Options] = useState();
  const [assets2OptionsCheck, setAssets2OptionsCheck] = useState(true);
  const [rejectedReq, setRejectedReq] = useState(0);
  const [pendingReq, setPendingReq] = useState(0);
  const [completedReq, setCompletedReq] = useState(0);
  const [allReq, setAllReq] = useState(0);
  const [isExpanded, setIsExpanded] = useState(true);
  const [hasShifted, setHasShifted] = useState(false);

  useEffect(() => {
    getAdminCardsData();
    if (props.role == 6 || props.role == 7) {
      getAllBlocksFromDistrict(props.userData.district_code).then((res) => {
        if (res.status == "success") {
          setAllBlocks(res.data.new_asset_query);
        } else {
          setAllBlocks([]);
        }
      });
    }

    if (props.role == 5) {
      const data = {
        block_code: props.userData.block_code,
      };
      school_name_block_wise(data)
        .then((response) => {
          if (response.status == "success") {
            setAllSchoolNames(response.data.result);
          } else {
            setAllSchoolNames([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching districts:", error);
        });
    }
  }, []);

  const getAdminCardsData = () => {
    setIsLoading(true);
    const newReqData =
      props.role == 4
        ? {
            role_id: 4,
            school_id: props.userData.school_id,
          }
        : props.role == 5
        ? {
            role_id: 5,
            district_code: props.userData.district_code,
            block_code: props.userData.block_code,
            school_id: schoolId === "" ? "all" : schoolId,
          }
        : props.role == 6 || props.role == 7
        ? {
            role_id: props.role == 6 ? 6 : 7,
            district_code: props.userData.district_code,
            block_code: Block === "" ? "all" : Block,
            school_id: schoolId === "" ? "all" : schoolId,
          }
        : {
            role_id: 8,
            district_code: District === "" ? "all" : District,
            block_code: Block === "" ? "all" : Block,
            school_id: schoolId === "" ? "all" : schoolId,
          };

    amenity_wise_req_kpi_dashboard(newReqData)
      .then((res) => {
        if (res.status === "success") {
          const options = {
            chart: {
              type: "pie",
              backgroundColor: "transparent",
            },
            title: {
              text: `${t("Total Count")}<br><span style="font-size: 30px">${
                res.totalQuantity
              }</span>`,
              verticalAlign: "middle",
              y: 25,
              x: 0,
              style: {
                fontSize: "20px",
              },
            },
            plotOptions: {
              pie: {
                size: "75%",
                innerSize: "50%",
                events: {
                  click: function (event) {
                    const clickedSliceName = event.point.name.split(":")[0];
                    const subtypeData =
                      res.data.find((asset) => asset.type === clickedSliceName)
                        ?.subtypes || [];
                    appendList(clickedSliceName, subtypeData);
                  },
                },
              },
            },
            series: [
              {
                name: t("Total"),
                data: res.data.map((asset) => ({
                  name: asset.type + ": " + asset.total_quantity,
                  y: asset.total_quantity,
                })),
              },
            ],
            colors: [
              "blue",
              "lightgreen",
              "red",
              "orange",
              "skyblue",
              "yellow",
            ],
          };
          setAssetsOptions(options);
          setAssetsOptionsCheck(false);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error(t("Something went wrong"));
        setIsLoading(false);
      });

    amenity_wise_shortage_count_kpi_dashboard(newReqData)
      .then((res) => {
        if (res.status === "success") {
          const options = {
            chart: {
              type: "column",
              backgroundColor: "transparent",
            },
            title: {
              text: "",
            },
            xAxis: {
              categories: [
                "Personal",
                "Infra",
                "Common",
                "Furniture",
                "Building Infra",
                "Electrical & Electronics",
              ],
              gridLineWidth: 0,
            },
            yAxis: {
              title: {
                text: "",
              },
              gridLineWidth: 0,
            },
            plotOptions: {
              column: {
                color: "orange",
              },
            },
            series: [
              {
                name: "Total Shortage Count",
                data: [
                  {
                    name: "Personal",
                    y: res.data.personal.total_shortage_count,
                  },
                  { name: "Infra", y: res.data.infra.total_shortage_count },
                  { name: "Common", y: res.data.common.total_shortage_count },
                  {
                    name: "Furniture",
                    y: res.data.furniture.total_shortage_count,
                  },
                  {
                    name: "Building Infra",
                    y: res.data.building_infra.total_shortage_count,
                  },
                  {
                    name: "Electrical & Electronics",
                    y: res.data.electricals_and_electronics
                      .total_shortage_count,
                  },
                ],
              },
            ],
          };
          setAssets2Options(options);
          setAssets2OptionsCheck(false);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error(t("Something went wrong"));
        setIsLoading(false);
      });

    getDashboardRejectedRequirements(newReqData)
      .then((res) => {
        setRejectedReq(res.data[0].total);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error(t("Something went wrong"));
        setIsLoading(false);
      });

    getDashboardPendingRequirements(newReqData)
      .then((res) => {
        setPendingReq(res.data[0].total);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error(t("Something went wrong"));
        setIsLoading(false);
      });

    getDashboardCompletedRequirements(newReqData)
      .then((res) => {
        setCompletedReq(res.data[0].total);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error(t("Something went wrong"));
        setIsLoading(false);
      });

    getDashboardAllRequirements(newReqData)
      .then((res) => {
        setAllReq(res.data[0].total);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error(t("Something went wrong"));
        setIsLoading(false);
      });
  };

  const appendList = (clickedSliceName, subtypeData) => {
    console.log(subtypeData);
    let listItemHtml = `
      <ul class="list-group">
        <span class="fs-5 my-2" style="font-size: 13px;">
          ${clickedSliceName}
        </span>
        <li class="list-group-item p-3 px-4 d-flex justify-content-between align-items-center">
          <span class="text-secondary fw-bold col-4 text-start" style="font-size: 13px;">
            Sr. No.
          </span>
          <span class="text-secondary fw-bold col-4 text-center" style="font-size: 13px;">
            Asset Sub Type
          </span>
          <span class="text-secondary fw-bold col-4 text-end" style="font-size: 13px;">
            Raised Quantity
          </span>
        </li>
        ${subtypeData
          .map(
            (subtype, index) => `
          <li class="list-group-item p-4 d-flex justify-content-between">
            <span>${index + 1}</span>
            <span>${subtype.subtype_name}</span>
            <span>${subtype.quantity}</span>
          </li>
        `
          )
          .join("")}
      </ul>
    `;

    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.innerHTML = listItemHtml;
    }
  };

  const getDistictNames = () => {
    getdistictName()
      .then((res) => {
        if (res.status === "success") {
          console.log("dis data:", res.data);
          setDistrictName(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  };

  useEffect(() => {
    getDistictNames();
  }, []);

  const handleDistrictChange = (e) => {
    const selectedDistrictId = e.target.value;
    setDistrict(e.target.value);
    setAllBlocks([]);
    setAllSchoolNames([]);

    getAllBlocksFromDistrict(selectedDistrictId).then((res) => {
      if (res.status == "success") {
        setAllBlocks(res.data.new_asset_query);
      } else {
        setAllBlocks([]);
      }
    });
  };

  const handleBlockChange = (e) => {
    setBlock(e.target.value);
    setAllSchoolNames([]);

    const data = {
      block_code: e.target.value,
    };
    school_name_block_wise(data)
      .then((response) => {
        if (response.status == "success") {
          setAllSchoolNames(response.data.result);
        } else {
          setAllSchoolNames([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  };

  const handleSchoolName = (e) => {
    try {
      setSchoolId(e.target.value);
    } catch (error) {
      console.error("Error parsing JSON in handleSchoolName:", error);
    }
  };

  const renderChart = (options, isEmpty) => {
    if (isLoading) {
      return <Spinner />;
    } else if (isEmpty) {
      return (
        <div className="col-sm-12 col-md-12 mb-4">
          <div className="">
            <div className=" p-5">
              <h5 className="card-title text-center">No data found</h5>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="col-sm-12 col-md-12 mb-4">
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
      );
    }
  };

  const shiftDiv = () => {
    if (!hasShifted) {
      setIsExpanded(!isExpanded);
      setHasShifted(true);
    }
  };

  return (
    <div className="row">
      <div className="row justify-content-between mb-3">
        <div className="col-6 d-flex align-items-center">
          <h3 className="fs-4 mt-4">{t("Requirements")}</h3>
        </div>
        <div className="col-6 d-flex align-items-center justify-content-end">
          {props.role == 8 ||
          props.role == 11 ||
          props.role == 12 ||
          props.role == 13 ? (
            <div className="col-md-3 mx-2">
              <label htmlFor="title" className="form-label">
                {t("District")}
              </label>
              <select
                name="asset_sub_type"
                onChange={handleDistrictChange}
                className="common-input form-select"
              >
                <option value="all">All</option>
                {DistrictName &&
                  DistrictName.map((row, id) => (
                    <option
                      key={id}
                      value={row.district_code}
                      className="text-dark"
                    >
                      {row.name}
                    </option>
                  ))}
              </select>
            </div>
          ) : (
            ""
          )}
          {props.role == 6 ||
          props.role == 7 ||
          props.role == 8 ||
          props.role == 11 ||
          props.role == 12 ||
          props.role == 13 ? (
            <div className="col-md-3 mx-2">
              <label className="form-label">{t("Block")} </label>
              <select
                name="Block"
                className="common-input form-select"
                onChange={handleBlockChange}
                required
              >
                <option value="all">All</option>
                {Allblocks &&
                  Allblocks.map((row, index) => (
                    <option key={index} value={row.code}>
                      {row.name}
                    </option>
                  ))}
              </select>
            </div>
          ) : (
            ""
          )}
          {props.role == 5 ||
          props.role == 6 ||
          props.role == 7 ||
          props.role == 8 ||
          props.role == 11 ||
          props.role == 12 ||
          props.role == 13 ? (
            <div className="col-md-3 mx-2">
              <label className="form-label">{t("School")} </label>
              <select
                name="SchoolName"
                className="common-input form-select"
                onChange={handleSchoolName}
                required
              >
                <option value="all">All</option>
                {AllSchoolNames &&
                  AllSchoolNames.map((row, index) => (
                    <option value={row.school_id}>{row.school_name}</option>
                  ))}
              </select>
            </div>
          ) : (
            ""
          )}

          {props.role == 4 ? (
            ""
          ) : (
            <button
              className="btn btn-primary btn-sm  mx-2"
              style={{ marginTop: "28px" }}
              onClick={getAdminCardsData}
            >
              {t("Search")}
            </button>
          )}
        </div>
      </div>
      <div className="my-3 col-12 d-flex align-items-center justify-content-between">
        <div className="col-md-3 mx-1">
          <div className="card card2">
            <div className="card-body hello2">
              <h3 className="card-title text-white">{t("Pending")}</h3>
              <h6 className="text-white">
                {t("")}
                <br />
              </h6>
              <motion.div>
                <div className="radialBar d-flex justify-content-end">
                  <span className="text-white larger-text fs-3">
                    {pendingReq > 0 ? pendingReq : 0}
                  </span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="col-md-3 mx-1">
          <div className="card card3">
            <div className="card-body hello3">
              <h3 className="card-title text-white">{t("Completed")}</h3>
              <h6 className="text-white">
                {t("")}
                <br />
              </h6>
              <motion.div>
                <div className="radialBar d-flex justify-content-end">
                  <span className="text-white larger-text fs-3">
                    {completedReq > 0 ? completedReq : 0}
                  </span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="col-md-3 mx-1">
          <div className="card card1">
            <div className="card-body hello1">
              <h3 className="card-title text-white">{t("Rejected")}</h3>
              <h6 className="text-white">
                {t("")}
                <br />
              </h6>
              <motion.div>
                <div className="radialBar d-flex justify-content-end">
                  <span className="text-white larger-text fs-3">
                    {rejectedReq > 0 ? rejectedReq : 0}
                  </span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="col-md-3 mx-1">
          <div className="card card3">
            <div className="card-body hello4">
              <h3 className="card-title text-white">{t("Total")}</h3>
              <h6 className="text-white">
                {t("")}
                <br />
              </h6>
              <motion.div>
                <div className="radialBar d-flex justify-content-end">
                  <span className="text-white larger-text fs-3">
                    {allReq > 0 ? allReq : 0}
                  </span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      <h3 className="text-dark my-4 col-12">
        {t("Asset Wise - Requirement Raised")}
      </h3>
      <div className="col-12 row d-flex justify-content-center ">
        <div
          className={`${
            isExpanded ? "col-12" : "col-6"
          } d-flex justify-content-center align-items-center transition-class ${
            hasShifted ? "shifted" : ""
          }`}
          onClick={shiftDiv}
        >
          {renderChart(assetsOptions, assetsOptionsCheck)}
        </div>

        <div className="col-6 d-flex justify-content-center">
          <div
            className="col-10 d-flex row justify-content-center"
            id="list-container"
          ></div>
        </div>
      </div>
      <h3 className="text-dark my-2 mb-5 col-12">
        {t("Asset Wise - Shortage")}
      </h3>
      {renderChart(assets2Options, assets2OptionsCheck)}
      <h3 className="text-dark mt-2 mb-4">
        {t("Map View - Pending Requirements")}
      </h3>
      <Map />
    </div>
  );
};

export default AdminCards;
